import script from "./TrainWalletPayModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainWalletPayModal.vue?vue&type=script&setup=true&lang=js"

import "./TrainWalletPayModal.vue?vue&type=style&index=0&id=dcb56d4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcb56d4c"]])

export default __exports__